// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__s5RxG","table":"Table_table__9uBOQ","row":"Table_row__FSfUn","col":"Table_col__UKuDa","tooltip":"Table_tooltip__wwfTo"};